//symbol, letter & capital letter and number 
export function passwordValidation(password) {
    return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/gm.test(password)
}